import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from '../Intl/withIntl.js';
import classNames from 'classnames';
import { Button, Form } from 'react-bootstrap';

function Autocomplete({ intl, items = [], name = '', value = '', inputProps = {}, getItemValue = null, getItemId = null, getItemLabel = null, renderItem = null, onChange = null, onSelect = null, filter = null }) {
	const [activeitems, setItems] = useState(items || []);
	const [search, setSearch] = useState(value || '');
	const [isOpen, setIsOpen] = useState(false);
	const searchInput = useRef(null);
	const searchResults = useRef(null);

	const getItemValueP = item => (getItemValue || (i => i[(name || inputProps?.name) || 'value']))(item);
	const getItemIdP = item => (getItemId || (i => i.id || getItemValueP(i)))(item);
	const getItemLabelP = item => (getItemLabel || getItemValue || (i => i?.label || i?.value || ''))(item);

	const handleChangeInput = event => {
		const search = event.target.value;
		setSearch(search);
		onChange && onChange(search);
	};

	const handleFilter = item => {
		// console.log('Search for', search, getItemValue(item), getItemLabel(item));
		if(filter) {
			return filter(item, search);
		}
		return (getItemLabelP(item) || '').toLowerCase().includes(((search || '').toLowerCase())) || (getItemValueP(item) || '').toLowerCase().includes((search || '').toLowerCase());
	};

	const handleSelect = item => {
		// console.log('Selected', item);
		setSearch(getItemLabelP(item));
		setIsOpen(false);
		onSelect && onSelect(item);
	};

	const getFilteredItems = () => {
		return (activeitems || []).filter(handleFilter);
	};

	useEffect(() => {
		setItems(items);
	}, [items]);

	useEffect(() => {
		setSearch(value);
	}, [value]);

	// console.log(items, getFilteredItems());

	const isResultsOpen = () => {
		return (
			isOpen && (
				document.activeElement === searchInput.current
				|| document.activeElement === searchResults.current
			)
		);
	};

    return (
		<div
			className="position-relative"
			onFocus={() => setIsOpen(true)}
		>
			<Form.Control
				className="w-full p-1.5"
				value={search}
				onChange={handleChangeInput}
				ref={searchInput}
				{...inputProps}
			/>
			{/* {process.env.NODE_ENV === 'development' && <Button onClick={() => setIsOpen(!isOpen)}>{isOpen ? 'Close' : 'Open'}</Button>} */}
			<ul
				className={`position-absolute w-100 bg-white mt-1 border border-top-0 overflow-scroll p-0 list-unstyled shadow ${!isResultsOpen() && 'd-none'}`}
				style={{ top: '75%', zIndex: 999, borderRadius: '0 0 5px 5px', maxHeight: '200px', borderColor: 'var(--bs-border-width)' }}
				ref={searchResults}
			>
				{
					getFilteredItems().length > 0
					? getFilteredItems().map((item, index) => (
						<li
							className={classNames(
								// highlightedIndex === index && 'bg-blue-300',
								// selectedItem === item && 'font-bold',
								'py-2 px-3 shadow-sm flex flex-col',
							)}
							key={getItemIdP(item)}
							onClick={() => handleSelect(item)}
						>
							{(renderItem || getItemLabelP)(item)}
						</li>
					))
					: (
						<li className="py-2 px-3 shadow-sm flex flex-col" style={{ cursor: 'pointer' }}>
							{intl.formatMessage({ id: 'elementNoItems', defaultMessage: 'No item' })}
						</li>
					)
				}
			</ul>
		</div>
    );
}

Autocomplete.propTypes = {
	intl: PropTypes.object.isRequired,
	items: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
	onSelect: PropTypes.func.isRequired,
	getItemId: PropTypes.func,
	getItemValue: PropTypes.func,
	getItemLabel: PropTypes.func,
	renderItem: PropTypes.func,
	filter: PropTypes.func,
	name: PropTypes.string,
	value: PropTypes.any,
	inputProps: PropTypes.object,
};

export default injectIntl(Autocomplete);
